import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage     from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage    from './pages/AboutPage';
import ContactPage  from './pages/ContactPage';
import { HelmetProvider } from 'react-helmet-async';
import Blog from './pages/Blog';
import PostDetail from './pages/PostDetail';

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/"         element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/about"    element={<AboutPage />} />
        <Route path="/blog"     element={<Blog />} />
        <Route path="/blog/:id" element={<PostDetail />} />
        <Route path="/contact"  element={<ContactPage />} />
        <Route path="*"         element={<HomePage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
